import PropTypes from 'prop-types';
import { requiredIfOtherIsUndefined } from '../../utils/propUtils';

// Using this temp object to handle recursive dependency on 'group' property
const _ModelPropType = {
  path: requiredIfOtherIsUndefined('group'),
  type: requiredIfOtherIsUndefined('group', PropTypes.function),
  label: PropTypes.string,
  disabled: PropTypes.bool,
  hasError: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  properties: PropTypes.object,
  isRequired: PropTypes.bool
};

_ModelPropType.group = PropTypes.arrayOf(PropTypes.shape(_ModelPropType));

export const ModelPropType = PropTypes.shape(_ModelPropType);
